import { render, staticRenderFns } from "./Mission.vue?vue&type=template&id=2624f852&"
import script from "./Mission.vue?vue&type=script&lang=js&"
export * from "./Mission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports